module.exports = __webpack_public_path__ + "img/LOVAL-Will-Version_old.b22603a1.svg";